import { useLang } from '@/i18n';
import EfImg from 'elem/ui/ef-img';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { useState, useEffect } from 'react';
import gtm from '@/utils/gtm';

export default function TheComp() {
    const { t } = useLang('hat');
    const { locale = 'us' } = useRouter();

    const handlePlay = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow Power Hat: Power all your adventures',
            position: `Product Detail_2`,
        });
    };

    return (
        <div className={styles.TheComp}>
            <div className="img">
                <div id="player-hat2" className="youtube-iframe" onClick={handlePlay}>
                    <iframe className="youtube-iframe" src={`https://www.youtube.com/embed/CTTUN14F44o`} />
                </div>
            </div>
        </div>
    );
}
